import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

export default function BarChartsHorizontal(data) {
  const totalItems = data?.data?.keyData?.length;
  const visibleItems = 5;

  const options = {
    title: {
      text: data.heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "2%",
      right: "5%",
      bottom: "1%",
      top: "20%",
      containLabel: true,
    },
    xAxis: {
      axisLabel: {
        show: false,
      },
      type: "value",
      min: 0.1,
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: data?.data?.keyData,
      axisLabel: {
        fontSize: 14,
        width: 70,
        overflow: "truncate",
      },
      splitLine: {
        show: false,
      },
    },
    series: [
      {
        data: data?.data?.valData,
        type: "bar",
        barWidth: 15,
        barMinHeight: 30,
        itemStyle: {
          barBorderRadius: [0, 7, 7, 0],
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: data.color[0] },
            { offset: 1, color: data.color[1] },
          ]),
        },
        label: {
          show: true,
          position: data.p,
          fontWeight: 500,
          color: "#000",
        },
      },
    ],
    ...(totalItems > 5 && {
      dataZoom: [
        {
          type: "slider",
          yAxisIndex: 0,
          start: 100 - (visibleItems / totalItems) * 100,
          end: 100,
          orient: "vertical",
          handleSize: 5,
          width: 10,
          showDetail: false,
          fillerColor: "#2A5775",
          backgroundColor: "#ccc",
          handleColor: "#2A5775",
          zoomOnMouseWheel: false,
          moveOnMouseMove: false,
          moveOnMouseWheel: false,
          right: 0,
          zoomLock: true,
        },
      ],
    }),
  };

  return <ReactECharts option={options} style={{ height: data.h }} />;
}
